import { CellContext } from '@tanstack/react-table';
import { getFormTableFieldName } from './utils';
import { FormField } from '../../FormField';
import { getDatePeriodString } from '../../../utils';
import { FormDateRangePicker, FormDateRangePickerProps } from '../../input';

export const FormTableDateRangeField = <RowData,>(
  props: CellContext<RowData, any> & Omit<FormDateRangePickerProps, 'name'>,
) => {
  const { allowEmpty = [true, true], ...rest } = props;
  const name = getFormTableFieldName(props);
  return (
    <FormField
      name={name}
      size="small"
      preview={{
        render: (value) => getDatePeriodString(value?.[0], value?.[1]),
      }}
    >
      <FormDateRangePicker
        size="small"
        name={name}
        allowEmpty={allowEmpty}
        autoFocus
        {...rest}
      />
    </FormField>
  );
};
